<template>
  <custom-callout :has-toggle="false" class="mt-2" border-color="gray">
    <div class="row mt-2 test">
      <div class="col-md-12 pt-3">
        <div class="row">
          <div class="col-md-2 col-6">
            <div class="info-text-title">
              Título:
            </div>
            <p class="info-text">
              {{ value.title }}
            </p>
          </div>
          <div class="col-md-2 col-6">
            <div class="info-text-title">
              Materia:
            </div>
            <p class="info-text">
              {{ value.subject }}
            </p>
          </div>
          <div class="col-md-2 col-6">
            <div class="info-text-title">
              Grado:
            </div>
            <p class="info-text">
              {{ value.grade }}
            </p>
          </div>
          <div class="col-md-2 col-6">
            <div class="info-text-title">
              ISBN:
            </div>
            <p class="info-text">
              {{ value.isbn }}
            </p>
          </div>
          <div class="col-md-2 col-6">
            <div class="info-text-title">
              Autor:
            </div>
            <p class="info-text">
              {{ value.author }}
            </p>
          </div>
          <div class="col-md-2 col-6">
            <action-button
              :text="selectBtnText"
              i="far fa-check"
              variant="outline-success btn-transparent"
              @click="$emit('onSelectBook', value)"
            />
          </div>
        </div>
      </div>
    </div>
  </custom-callout>
</template>

<script>
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import store from '@/store/index';
import mixWait from '@/mixin/loading.mixin';
import alert from '@/mixin/alert.mixin';

export default {
  name: 'BookRequestSearchResultRow',
  components: {
    CustomCallout,
    ActionButton,
  },
  computed: {
    selectBtnText() {
      let text = store.getters.getIsMobileDensity ? '' : 'Seleccionar';
      return text;
    },
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  mixins: [mixWait, alert],
};
</script>

<style scoped>
.btn-transparent {
  background-color: transparent !important;
}
.ab-btn-outline-success:hover {
  color: #fff;
  background-color: #2db782 !important;
}
.mrc {
  margin-left: 30px;
}
.info-text {
  color: #11291b !important;
  font-weight: 600;
}
.info-text-title {
  color: #727272 !important;
  font-size: 14px !important;
  font-weight: normal;
}
.orange-icon {
  color: #ff7058;
}

@media only screen and (max-width: 375px) {
  .btn-transparent >>> .fa-check {
    margin-right: 0px !important;
  }

  .info-text-title {
    color: #727272 !important;
    font-size: 12px !important;
    font-weight: normal;
  }
  .info-text {
    color: #11291b !important;
    font-weight: normal;
    font-size: 12px;
  }
}
</style>
